<template>
  <div @click.stop class="text-xs-center mt-2">
    <v-dialog width="700">
      <!-- A button to show more predictions-->
      <template #activator="{on}">
        <v-btn v-on="on" color="blue-grey lighten-4" round small>Más predicciones</v-btn>
      </template>
      <!-- The table with predictions -->
      <v-items-card-predictions-table :item="item" />
    </v-dialog>
  </div>
</template>

<script>
import VItemsCardPredictionsTable from "./ItemCardPredictionsTable";

export default {
  components: {
    VItemsCardPredictionsTable
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>